import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/evcs_connectors',
  component: Management,
  redirect: '/evcs_connectors/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/evcs_connectors/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listEvcsConnectors
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/evcs_connectors/ListTable'),
          meta: {
            auth: Auth.listEvcsConnectors,
            tabName: 'all'
          }
        },
        {
          path: 'offline',
          component: () => import('@/views/evcs_connectors/ListTable'),
          meta: {
            auth: Auth.listEvcsConnectors,
            tabName: 'offline'
          }
        },
        {
          path: 'available',
          component: () => import('@/views/evcs_connectors/ListTable'),
          meta: {
            auth: Auth.listEvcsConnectors,
            tabName: 'available'
          }
        },
        {
          path: 'ready',
          component: () => import('@/views/evcs_connectors/ListTable'),
          meta: {
            auth: Auth.listEvcsConnectors,
            tabName: 'ready'
          }
        },
        {
          path: 'charging',
          component: () => import('@/views/evcs_connectors/ListTable'),
          meta: {
            auth: Auth.listEvcsConnectors,
            tabName: 'charging'
          }
        },
        {
          path: 'reserved',
          component: () => import('@/views/evcs_connectors/ListTable'),
          meta: {
            auth: Auth.listEvcsConnectors,
            tabName: 'reserved'
          }
        },
        {
          path: 'fault',
          component: () => import('@/views/evcs_connectors/ListTable'),
          meta: {
            auth: Auth.listEvcsConnectors,
            tabName: 'fault'
          }
        },
        {
          path: 'unknown',
          component: () => import('@/views/evcs_connectors/ListTable'),
          meta: {
            auth: Auth.listEvcsConnectors,
            tabName: 'unknown'
          }
        }
      ]
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/evcs_connectors/DetailLayout'),
      meta: {
        auth: Auth.showEvcsConnector
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/evcs_connectors/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showEvcsConnector
          }
        },
        {
          path: 'orders',
          component: () => import('@/views/evcs_connectors/details/Orders'),
          meta: {
            tabName: 'orders',
            auth: Auth.showEvcsConnector
          }
        },
        {
          path: 'connector_traces',
          component: () => import('@/views/evcs_connectors/details/ConnectorTraces'),
          meta: {
            tabName: 'connector_traces',
            auth: Auth.showEvcsConnector
          }
        }
      ]
    }
  ]
}
